<template>
    <section
        class="search-preferences-new--item"
        :class="{ full }"
    >
        <slot />
    </section>
</template>

<script>
export default {
    props: {
        full: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
